import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import AdminDetailEdit from "./AdminProfileEdit";
import ApiService from "../../services/httpService";
import alertify from "alertifyjs";

const Profile = () => {
  const [menu, setMenu] = useState(false);
  const [admin, setAdmin] = useState(true);
  const [editUser, setEditUser] = useState({
    Name: "",
    Email: "",
    Phone: "",
    Address: "",
    City: "",
    State: "",
    GeoLocation: "",
    Status: 0,
    ID: 0,
    Profile: "",
  });
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const togglePhoneMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    const NewUser = JSON.parse(localStorage.getItem("user"));
    setEditUser(NewUser);
  }, []);

  const passwordValidation = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{6,}$/;

  const handleChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    // Validate password on every change
    if (!passwordValidation.test(value)) {
      setErrorMessage(
        "Password must be at least 6 characters, include an uppercase letter, a lowercase letter, and a special character."
      );
    } else {
      setErrorMessage("");
    }
  };

  const toastrSuccess = (message) => {
    alertify.dismissAll();
    alertify.set("notifier", "position", "top-right");
    alertify.success(message);
  };

  const toastrError = (message) => {
    alertify.dismissAll();
    alertify.set("notifier", "position", "top-right");
    alertify.error(message);
  };

  const HandleSavePassword = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (errorMessage) {
      // If there's an error, don't submit
      toastrError("Please fix the errors before submitting.");
      return;
    }

    // Send the data to the server (e.g., using fetch or axios)
    try {
      const User_id = localStorage.getItem("user_id");

      if (!User_id) {
        toastrError("User not found.");
        return;
      }
      const fullCode = {
        UserID: Number(User_id),
        Password: password,
      };
      console.log("fullCode: ", fullCode);
      console.log(
        "link",
        `https://api.cenpilot.in/api/CenPilot/UpdatePassword`
      );

      const response = await ApiService.postPublic(
        `api/CenPilot/UpdatePassword`,
        fullCode
      );

      console.log("response: ", response);

      if (response == "Password Updated successfully.") {
        toastrSuccess("Password saved successfully!");
        setPassword("");
      } else {
        toastrError("Failed to save password.");
      }
    } catch (error) {
      toastrError("An error occurred while saving the password.");
    }
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => togglePhoneMenu()} />
        <Sidebar />

        {/** Page Wrapper  */}
        {editUser && admin && (
          <div className="page-wrapper">
            <div className="content container-fluid">
              <div className="row justify-content-lg-center">
                <div className="col-lg-10">
                  <div className="page-header">
                    <div className="content-page-header">
                      <h5>Profile</h5>
                    </div>
                  </div>
                  {/* /Page Header */}
                  <div className="profile-cover">
                    <div className="profile-cover-wrap">
                      {editUser.Profile ? (
                        <img
                          className="profile-cover-img"
                          src={`https://api.cenpilot.in${editUser.Profile}`}
                          alt="Profile Image"
                          id="blah"
                        />
                      ) : (
                        <img
                          className="profile-cover-img"
                          src={`https://www.themodelskit.co.uk/wp-content/uploads/2021/01/shutterstock_376903072-731x1024.jpg`}
                          alt="Profile Image"
                          id="blah"
                        />
                      )}
                    </div>
                  </div>
                  <div className="text-center mb-5">
                    <label
                      className="avatar avatar-xxl profile-cover-avatar"
                      htmlFor="avatar_upload"
                    >
                      {editUser.Profile ? (
                        <img
                          className="avatar-img"
                          src={`https://api.cenpilot.in${editUser.Profile}`}
                          alt="Profile Image"
                          id="blah"
                        />
                      ) : (
                        <img
                          className="avatar-img"
                          src={`https://www.themodelskit.co.uk/wp-content/uploads/2021/01/shutterstock_376903072-731x1024.jpg`}
                          alt="Profile Image"
                          id="blah"
                        />
                      )}
                    </label>
                    <h2>{editUser.Name}</h2>
                    <ul className="list-inline">
                      {editUser.Email && (
                        <li className="list-inline-item">
                          <i className="far fa-building" />
                          <span className="ms-2">{editUser.Email} </span>
                        </li>
                      )}
                      {editUser.City && (
                        <li className="list-inline-item">
                          <i className="fas fa-map-marker-alt" />
                          <span className="ms-2">{editUser.City}</span>
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="card">
                        <div className="card-header">
                          <h5 className="card-title d-flex justify-content-between align-items-center">
                            <span>Profile</span>
                            <button
                              className="btn btn-sm btn-white"
                              onClick={() => {
                                setAdmin(false);
                              }}
                            >
                              Edit
                            </button>
                          </h5>
                        </div>
                        <div className="card-body">
                          <ul className="list-unstyled mb-0 d-flex flex-column gap-1">
                            <li className="py-0">
                              <h6>About</h6>
                            </li>
                            <li>{editUser.Name}</li>
                            {editUser.gender && <li>{editUser.gender}</li>}
                            <li className="pt-2 pb-0">
                              <h6>Contacts</h6>
                            </li>
                            {editUser.Email && <li>{editUser.Email}</li>}
                            {editUser.Phone && <li>{editUser.Phone}</li>}
                            <li className="pt-2 pb-0">
                              <h6>Address</h6>
                            </li>
                            <li>
                              {editUser.Address},
                              <br />
                              {editUser.City}
                              <br />
                              {editUser.State},
                              <br />
                            </li>
                            <li className="pt-2 pb-0">
                              <h6>Location</h6>
                            </li>
                            <li>
                              <a
                                href={`https://www.google.com/maps?q=${editUser.GeoLocation}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="fa-solid fa-map"></i> Map
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="card">
                        <div className="card-header">
                          <h5 className="card-title d-flex justify-content-between align-items-center">
                            More Details
                            <button
                              type="button"
                              className="btn btn-sm btn-link"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                              data-bs-whatever="@mdo"
                            >
                              Change Password
                            </button>
                          </h5>
                        </div>
                        <div className="card-body card-body-height">
                          <p className="text-center">No more Data..</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {!admin && (
          <AdminDetailEdit
            editUser={editUser}
            setEditModal={setAdmin}
            setEditUser={setEditUser}
          />
        )}
      </div>
      {/* modal 3 */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                New Password
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your new password"
                    id="recipient-name"
                    value={password} // Bind input value to state
                    onChange={handleChange} // Update state when input changes
                  />
                </div>
                {errorMessage && (
                  <div style={{ color: "red", marginTop: "10px" }}>
                    {errorMessage}
                  </div>
                )}
              </form>
            </div>
            <div className="modal-footer gap-3">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={HandleSavePassword}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Profile;
